import barba from '@barba/core'
import { nodesToArray, stringToElements, removeElement } from '../utilities'

const activeClass = 'is-active'
const disabledClass = 'is-disabled'
const loadingClass = 'is-loading'
const errorClass = 'is-error'

export default class {
  constructor(el, options) {
    this.el = el
    this.options = options

    let errors = []

    const responseEl = el.querySelector('.js-formResponse')
    const textInputs = nodesToArray(el.querySelectorAll('input, textarea'))
    const submitButton = el.querySelector('.js-formButton')

    textInputs.forEach(function (inputEl) {
      inputEl.addEventListener('keyup', function onKeyUp(e) {
        if (
          inputEl.value.length > 0 &&
          inputEl.classList.contains(errorClass)
        ) {
          inputEl.classList.remove(errorClass)
          inputEl.removeAttribute('aria-invalid')
          inputEl.removeEventListener('click', onKeyUp)
        }
      })
    })

    el.addEventListener('submit', onSubmit)

    function onSubmit(event) {
      if (responseEl) {
        responseEl.setAttribute('hidden', 'true')
        responseEl.innerHTML = ''
      }

      if (validate()) {
        submitButton.setAttribute('disabeld', 'true')
        submitButton.classList.add(disabledClass)
        submitButton.classList.add(loadingClass)

        const formData = new FormData(el)

        const data = {}
        formData.forEach(function (value, key) {
          data[key] = value
        })

        if (options.search) {
          barba.go(`${el.getAttribute('action')}?s=${data.s}`)
          onComplete()
        } else {
          window
            .fetch(`${window.ajax_url.url}?action=${data.action}`, {
              method: 'POST',
              body: JSON.stringify(data),
              mode: 'same-origin',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(checkStatus)
            .then(parseJSON)
            .then(onComplete)
            .catch(onError)
        }

        textInputs.forEach(function (el) {
          el.classList.remove(errorClass)
        })
      }

      event.preventDefault()
      return false
    }

    function onComplete(data) {
      if (data && responseEl) {
        responseEl.innerHTML = data.message || data
        responseEl.removeAttribute('hidden')
      }

      window.setTimeout(function () {
        submitButton.removeAttribute('disabeld')
        submitButton.classList.remove(disabledClass)
        submitButton.classList.remove(loadingClass)
      }, 5000)
    }

    function onError(error) {
      console.error('Request failed', error)

      window.setTimeout(function () {
        submitButton.removeAttribute('disabeld')
        submitButton.classList.remove(disabledClass)
        submitButton.classList.remove(loadingClass)
      }, 1000)
    }

    function checkStatus(response) {
      if (response.status >= 200 && response.status < 300) {
        return response
      } else {
        const error = new Error(response.statusText)
        error.response = response
        throw error
      }
    }

    function parseJSON(response) {
      console.error('parseJSON', response)
      return response.json()
    }

    function validate() {
      if (errors.length) {
        console.error(el, this)
        removeElement(document.querySelector('.js-formError'))
      }

      errors = []

      nodesToArray(el.querySelectorAll('[data-required=""]')).forEach(
        function (inputEl, index) {
          const isError = inputEl.value.length === 0
          inputEl.setAttribute('aria-invalid', isError ? 'true' : 'false')
          inputEl.classList.toggle('is-error', isError)

          if (isError) {
            errors.push(inputEl)
          }
        }
      )

      if (errors.length) {
        errors[0].focus({
          preventScroll: true,
        })

        el.insertBefore(
          stringToElements(
            '<div class="Form-item Form-item--error js-formError" role="alert"><p>All fields in the form are required.</p></div>'
          ),
          el.firstChild
        )
      }

      return errors.length === 0
    }

    // Floating labels
    function checkValue(inputEl) {
      inputEl.classList.toggle(activeClass, inputEl.value !== '')
      el.classList.toggle('has-content', inputEl.value !== '')
    }

    textInputs.forEach(function (textInput) {
      checkValue(textInput)

      textInput.addEventListener('change', function (e) {
        checkValue(e.target)
      })

      textInput.addEventListener('blur', function (e) {
        checkValue(e.target)
      })
    })

    window.setTimeout(function () {
      el.classList.add(activeClass)
    }, 100)
  }
}
